import {Box3} from "three";
import {cutOutsGroupName} from "../../constants/nameConstants.js";

// Vertical size of the wall itself. Cutouts are excluded: their markers and
// cut boxes extend past the wall and would inflate this measurement.
export function structuralWallHeight(wallGroup) {
    wallGroup.updateWorldMatrix(true, false);

    const bounds = new Box3();
    for (let i = 0; i < wallGroup.children.length; i++) {
        const child = wallGroup.children[i];
        if (child.name === cutOutsGroupName) {
            continue;
        }
        bounds.expandByObject(child);
    }

    return bounds.max.y - bounds.min.y;
}
